// extracted by mini-css-extract-plugin
export default {"img--hidden":"_1tvcNSAsZ7FHZejte4q3tp"};